/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BoldIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABNUlEQVR4nN2UMU7DUAyGO7AgVsQBGNjgCpk6ALH9BymxGxWxcQTEwszUA7ADEwsSMCDOQFm4QRmYEVAhRFBYaNLSvr4+BrDkzfo/2f7tRuPfhUhrg0VfGVb8lCT2zrAeiR0T2dpUABI9GCfOw9nnJLPfBBQlZHMrX/YF9Bh29J16RqKPI8Z26Au4qdc0m+0FgnYrdWJXwQBlMHS/2oFeNEICSKxTG1EnCCCOW4ux6DbDngdtC+iKL6AYfxP6JqK5k/i0ABJ7Kg/TWdynA/5ykJ6maTof5A6ofA/Q26FuoOdhXQTLGPYxWCuSrwYDlEGw+yrAYdmzAEhsLxiAk8zqIyLo7uxLhp2w2N0oN/nuoHC06vVEcV8AQbtJ0l5yAsTQdRJ7mSDaJ+gDQS8JthNF0ZyT+J+MT4Q207eJzsWmAAAAAElFTkSuQmCC)
 */
export const BoldIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M5.42 22a.9.9 0 0 1-.91-.9V2.9c0-.5.4-.9.9-.9h7.94c1.62 0 2.93.46 3.91 1.4 1 .92 1.5 2.15 1.5 3.67 0 1.2-.28 2.17-.86 2.9a4.8 4.8 0 0 1-2.23 1.57c1.18.25 2.1.78 2.78 1.59.7.8 1.04 1.9 1.04 3.33 0 1.86-.56 3.25-1.68 4.18-1.12.9-2.7 1.36-4.75 1.36H5.42Zm6.42-12c1.84 0 2.75-.73 2.75-2.2 0-1.47-.91-2.2-2.75-2.2h-3.1V10h3.1Zm.2 8.4c2.15 0 3.22-.8 3.22-2.4 0-1.6-1.07-2.4-3.22-2.4h-3.3v4.8h3.3Z"
        className={colorClass}
      />
    </svg>
  );
};
